'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScatterIcon = function TraceTypeScatterIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('circle', { cx: '13', cy: '32', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '21', cy: '27', r: '3', fill: '#25fdfc' }),
        _react2.default.createElement('circle', { cx: '23', cy: '18', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '32', cy: '24', r: '3', fill: '#25fdfc' }),
        _react2.default.createElement('circle', { cx: '32', cy: '11', r: '3', fill: '#25fdfc' })
    );
};

exports.default = TraceTypeScatterIcon;